import { memo } from "react";
import LeftNavbar from "./components/Header/LeftNavbar";
import Messages from "./components/Header/Messages";
import Notifications from "./components/Header/Notifications";
//import Search from './components/Header/Search';
import UserLogin from "./components/Header/UserLogin";
import NetworkStatus from "../../utils/NetworkStatus"; //// gọi file thong bao khi offline

function Header(props) {
    const users = JSON.parse(window.getFromStorage("user-info"));
    return (
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
            <NetworkStatus /> {/* Hien thi thong bao */}
            {/* Left navbar links */}
            <LeftNavbar nameOrganizeManager={users !== null ? users.nameOrganizeManager : ""}></LeftNavbar>
            {/* Right navbar links */}
            <ul className="navbar-nav ml-auto">
                {/* Navbar Search */}
                {/* <Search></Search> */}
                {/* Messages Dropdown Menu */}
                {/* <Messages></Messages> */}
                {/* Notifications Dropdown Menu */}
                {/* <Notifications></Notifications> */}
                {/* UserLogin Dropdown Menu */}
                <UserLogin users={users} avatar={props.avatar}></UserLogin>
                <li className="nav-item">
                    <a className="nav-link" data-widget="fullscreen" href="#" role="button">
                        <i className="fas fa-expand-arrows-alt" />
                    </a>
                </li>
            </ul>
        </nav>
    );
}

export default memo(Header);
